/** Check this link before editing https://material.angular.io/components/dialog/api */

import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { BrowserClipboardService } from "libraries/service/browserClipboard/browserClipboard.service";

/**
 * the text displayed in this component si injecgted by the component who open this modale.
 * the air trip text is generated,in "libraries/service/plainText/plainText.service.ts"
 */
@Component({
    selector: 'text-export-dialog',
    template: `
        <div mat-dialog-content>
            <card classList="no-spacing"
                  [isScrollable]="true">
                <ng-container class="card-header-content">
                    <h1>{{ wording.export}}</h1>

                    <div class="actions">
                        <btn type="actionDo"
                             [label]="wording.copy"
                             icon="fa fa-clipboard"
                             (click)="copy()"></btn>
                        <btn type="actionHeaderLink"
                             [label]="wording.close"
                             (click)="close()"></btn>
                    </div>
                </ng-container>

                <ng-container class="card-sub-header-content">
                    <notification type="success"
                                  *ngIf="copied"
                                  [autoClose]="true"
                                  (onClose)="copied = false">{{ wording.copiedSuccess }}</notification>
                    <notification type="warning"
                                  *ngIf="errorWhenCopying">{{ wording.copiedError }}</notification>
                </ng-container>

                <div class="card-body-content">
                    <textarea readonly>{{ text }}</textarea>
                </div>
            </card>
        </div>
    `,
    styleUrls: ['text-export-dialog.component.css']
})
export class TextExportDialogComponent implements OnInit {
    public copied: boolean = false;
    public errorWhenCopying: boolean = false;

    public wording: ILabels = {
        export: Yii.t("wui-shared-js", "Export au format texte"),
        close: Yii.t("wui-shared-js", "Fermer"),
        copy: Yii.t("wui-shared-js", "Copier dans le presse-papier"),
        copiedSuccess: Yii.t("wui-shared-js", "L'export a été copié dans le presse-papier"),
        copiedError: Yii.t("wui-shared-js", "L'export n'a pas pu être copié dans le presse-papier"),
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly text: string,
        private readonly matDialogRef: MatDialogRef<TextExportDialogComponent>,
        private readonly clipboardService: BrowserClipboardService
    ) {
    }

    public ngOnInit(): void {
        this.copy();
    }

    public copy(): void {
        this.copied = false;
        this.errorWhenCopying = false;

        this.clipboardService.copy(this.text)
            .then((): void => {
                this.copied = true;
            })
            .catch((): void => {
                this.copied = false;
                this.errorWhenCopying = true;
            });
    }

    public close(): void {
        this.matDialogRef.close();
    }
}
